define('commons/event-config-manager',['jquery'], function($) {

    var EventConfigManager = function(container, url, sourceTypeCode) {
        this.$container = $(container);
        this.changeUrl(url);
        this.sourceTypeCode = sourceTypeCode;
    };

    EventConfigManager.prototype.changeUrl = function(url) {
        this.url = "/event/config" + url;
    };

    EventConfigManager.prototype.getConfigList = function() {
        var here = this;
        $.ajax({
            type: 'GET',
            url: here.url,
            dataType: "html",
            success: function(data) {
                // Insert result
                here.$container.html(data);
                $("a#edit-config-link-" + here.sourceTypeCode).click(function(event) {
                    window.location = here.url + "/" + $(event.currentTarget).data("typeCode");
                });
                $("a#delete-config-link-" + here.sourceTypeCode).click(function(event) {
                    here.deleteConfig($(event.currentTarget).data("typeCode"));
                });
            }
        });
    };

    EventConfigManager.prototype.deleteConfig = function(eventTypeCode) {
        var here = this;
        if (confirm("You are about to delete this event configuration. Continue?")) {
            $.ajax({
                type: 'GET',
                url: here.url + "/" + eventTypeCode + "/delete",
                dataType: "json",
                success: function(data) {
                    here.getConfigList();
                }
            });
        }
    };

    return EventConfigManager;
});
